import { gql } from "@apollo/client";

const

/** Contacts team members */

Team = gql`query {

    contacts {

        id

        image

        title

        firstName

        lastName

        email

        phone

    }

}`,

LEGAL_DATA = gql`query LegalData($countryCode: String) {
    legalData(countryCode: $countryCode) {
        id
        legalEntityName
        registrationNumber
        countryCode
        legalAddress
        factualAddress
        phone
        servicePhone
        email
        bankAccounts {
            id
            iban
            bankName
            swiftCode
            isEnabled
            isDefault
        }
    }
}`,

WORKING_HOURS = gql`query {
    workingHours {
        startTimeMonday
        endTimeMonday
        startTimeTuesday
        endTimeTuesday
        startTimeWednesday
        endTimeWednesday
        startTimeThursday
        endTimeThursday
        startTimeFriday
        endTimeFriday
        startTimeSaturday
        endTimeSaturday
        startTimeSunday
        endTimeSunday
    }
}`;

/** Export queries */

export { Team, LEGAL_DATA, WORKING_HOURS }